import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@zinc/ui';

import Icon from 'bz-icons/src/controls/icon';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Menu from 'tm3-core/controls/menus';
import MenuStore from 'tm3-core/controls/menus/stores';
import ReportsList from '../../../reports-list';

@inject('clinicalStore')
@observer
class ReportsMenu extends React.Component {
  render() {
    return (
      <div>
        <Button
          icon={<FontAwesomeIcon icon={faPlus} />}
          variant={'outline'}
          size="small"
          onClick={this.onOpen}
        >
          Add Report
        </Button>
        <Menu
          dense={true}
          anchorEl={MenuStore.anchorEl}
          open={this.open}
          onClose={MenuStore.close}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <ReportsList />
        </Menu>
      </div>
    );
  }

  @computed
  get open() {
    return MenuStore.isOpen('clinical-footer-add-report');
  }

  @action.bound
  onOpen(e: any) {
    MenuStore.open('clinical-footer-add-report', e.currentTarget);
  }
}

export default ReportsMenu;
